import { useTranslation } from 'react-i18next';

import { IconFileShield02 } from '@pentabd/icons';
import { Header } from '@pentabd/ui';

interface GpfListPageHeaderProps {
  id: string | undefined;
}

export const GpfListPageHeader = ({ id }: GpfListPageHeaderProps) => {
  const { t } = useTranslation();

  const breadcrumbs = [
    {
      icon: <IconFileShield02 size="20" />,
    },
    {
      label: t('GPF_LIST.BREADCRUMBS.FIRST_STEP'),
    },
  ];

  // const actions = [
  //   <Link to={ROUTES.CREATE}>
  //     <Button
  //       fill="fill"
  //       size="sm"
  //       type="default"
  //       htmlType="button"
  //       className="py-5 bg-primary-lightest text-primary-middark border border-primary-lighter"
  //     >
  //       <IconFilePlus02 size="20" fill="info" />
  //       {t('GPF.INITIATE_BUTTON')}
  //     </Button>
  //   </Link>,
  // ];

  const headerText = {
    header: t('GPF_LIST.HEADING'),
    subHeader: t('GPF_LIST.DESCRIPTION'),
  };

  return (
    <Header
      breadcrumbs={breadcrumbs}
      headerText={headerText}
      // actions={actions}
    />
  );
};
